import { Component, Input, HostListener, ElementRef, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { ILogged } from '../../interfaces/ILogged';
import { isMobile } from '../../utils/helpers';
import { LoggedService } from '../../services/logged.service';
import { SidenavService } from '../../services/sidenav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  public Bayer: string
  public userName
  public logged?: ILogged;
  public Etiquetas: {


    CambiarClave:string,
    CerrarSesion:string,
    arialabel: string,
    FooterText: string,
    HeaderImage1: string,
    HeaderImage2: string,
    HeaderImage3: string,
    HeaderImage4: string,
    HeaderText: string,
    HeroImage1: string,
    HeroText2: string,
    HeroText3: string,
    Path: string,
    Titulo: string,


  }

  constructor(
    private configService: ConfigService,
    private loggedService: LoggedService,
    private router:Router,
    private sidenav: SidenavService) {
    this.loggedService.getLogged().subscribe((_logged: ILogged) => this.logged = _logged);

  }

  ngOnInit(): void {

    this.Bayer = this.configService.uri.Bayer
    this.Etiquetas = {
      CambiarClave: this.configService.etiquetas.MenuUsuario.CambiarClave,
      CerrarSesion: this.configService.etiquetas.MenuUsuario.CerrarSesion,
      arialabel: this.configService.etiquetas.Home.arialabel,
      FooterText: this.configService.etiquetas.Home.FooterText,
      HeaderImage1: this.configService.etiquetas.Home.HeaderImage1,
      HeaderImage2: this.configService.etiquetas.Home.HeaderImage2,
      HeaderImage3: this.configService.etiquetas.Home.HeaderImage3,
      HeaderImage4: this.configService.etiquetas.Home.HeaderImage4,
      HeaderText: this.configService.etiquetas.Home.HeaderText,
      HeroImage1: this.configService.etiquetas.Home.HeroImage1,
      HeroText2: this.configService.etiquetas.Home.HeroText2,
      HeroText3: this.configService.etiquetas.Home.HeroText3,
      Path: this.configService.etiquetas.Home.Path,
      Titulo: this.configService.etiquetas.Home.Titulo


    }


  }

  cambioClave() {
    this.router.navigateByUrl(this.configService.etiquetas.CambiarClave.Path);
  }
  logOut() {
    localStorage.setItem('logoutLogs', JSON.stringify(
      {
        timestamp: new Date(),
        reasonId: 1,
        source: 'header.component.ts'
      }
    ));
    
    this.loggedService.logOut(1);
  }

  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  isInRole(rol: string): boolean {

    return this.loggedService.isInRole(rol);
  }

  isLogged() {
    return this.loggedService.validToken();
  }

  isNewUser() {
    if (this.loggedService.validToken()) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }

  }

  isMobile() {
    return isMobile();
  }

}
